const STORAGE_KEY = 'evs.headerNotificationDismissed';

export const save = (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch (error) {
    // Ignore storage write errors to keep UI flow functional.
  }
};

export const get = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
};

export const remove = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Ignore storage remove errors to keep UI flow functional.
  }
};
